import { App } from './app.ts';

window.addEventListener('DOMContentLoaded', () => {
  new App();
});
